import { cn } from "@omni/utils/styles";

import { PopOver } from "@/components/General/PopOver/popOver.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

export const BvTrustMark = () => {
    const { t } = useGranite();

    return (
        <PopOver
            dismissable={false}
            anchorComponent={(
                setReference,
                getReferenceProps,
                popOverComponent
            ) => (
                <>
                    <img
                        ref={setReference}
                        src={`https://apps.bazaarvoice.com/common/images/intelligent_trustmark_icons/trustmark_${Config.getLanguage()}.png`}
                        alt={t("product.reviews.trustmark.alt")}
                        width={"auto"}
                        height={24}
                        className={cn("tw:h-6")}
                        {...getReferenceProps()}
                    />
                    {popOverComponent()}
                </>
            )}
        >
            <p>{t("product.reviews.trustmark.content")}</p>
            <p className={"mb-0"}>
                <a
                    href={`https://www.bazaarvoice.com/${Config.getLanguage()}/trustmark/`}
                    target={"_blank"}
                    rel="noopener"
                >
                    {t("product.reviews.trustmark.moreInfo")}
                </a>
            </p>
        </PopOver>
    );
};
